import {useEffect,useState} from 'react';
interface InstallEvent extends Event {prompt():Promise<void>;userChoice:Promise<{outcome:string}>}
export function useInstall(){
  const [prompt,setPrompt]=useState<InstallEvent|null>(null);
  useEffect(()=>{const handler=(event:Event)=>{event.preventDefault();setPrompt(event as InstallEvent);};window.addEventListener('beforeinstallprompt',handler);return()=>window.removeEventListener('beforeinstallprompt',handler);},[]);
  return {available:!!prompt,install:async()=>{if(prompt){await prompt.prompt();await prompt.userChoice;setPrompt(null);}}};
}
